<!--
 * @FileDescription: 成员管理对话框
 * @Author: 陈文景
 * @Date: 2022-09-22 14:34:32
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <el-dialog title="成员管理" :visible.sync="visible" width="50%" :before-close="close">
    <div class="role-tips"><span>当前角色: </span>{{ defaultTips(roleName) }}</div>

    <el-input v-model="parameter.searchContent" size="medium" clearable placeholder="根据用户名/邮箱/手机号搜索">
      <el-select v-model="parameter.searchType" size="medium" slot="prepend" placeholder="请选择" style="width:130px;">
        <el-option label="用户名" :value="1" />
        <el-option label="邮箱/手机号" :value="2" />
      </el-select>
      <el-button slot="append" size="medium" icon="el-icon-search" @click="getRolesMemberList" />
    </el-input>

    <div class="add-member-btn">
      <el-button size="medium" type="primary" round @click="addMember">添加成员</el-button>
    </div>

    <el-table v-loading="loading" size="medium" :data="memberList">
      <el-table-column prop="userId" label="用户ID" />
      <el-table-column prop="fullName" label="用户名" />
      <!-- <el-table-column prop="email" label="邮箱/手机号" /> -->
      <el-table-column prop="email" label="邮箱/手机号">
        <template slot-scope="{row}">
          <span>{{row.email}}</span>
          {{ row.email && row.phone ? '/' : '' }}
          <span>{{row.phone}}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="roleId !== 1" fixed="right" label="操作" width="80">
        <template v-slot="{ row }">
          <el-button type="text" size="medium" @click="() => deleteMember(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination background :page-sizes="[20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" :total="total" :current-page="parameter.pageNumber" @size-change="sizeChange" @current-change="currentChange" />
    </div>

    <!-- 添加成员对话框 -->
    <add-member-dialog ref="addMemberDialog" @update="getRolesMemberList" />
  </el-dialog>
</template>

<script>
import API from '@/api'
import AddMemberDialog from './AddMemberDialog.vue'

let parameter = {
  roleId: undefined, // 角色ID
  searchType: 1, // 搜索类型: 1.用户名 2.邮箱号
  searchContent: undefined, // 搜索关键字
  pageSize: 20,
  pageNumber: 1
}

export default {
  components: {
    'add-member-dialog': AddMemberDialog
  },
  data() {
    return {
      visible: false, // 控制对话框的显示与隐藏

      // 获取成员列表的请求参数
      parameter: { ...parameter },
      memberList: [], // 成员列表
      total: 0, // 成员列表总数量
      loading: false, // 表格loading

      roleId: undefined, // 当前角色ID
      roleName: undefined // 当前角色名称
    }
  },
  computed: {
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 获取对应角色的成员列表
     * @param {Boolean} reset 是否重置分页
     */
    async getRolesMemberList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        if (this.parameter.searchContent){
          this.parameter.searchContent = this.parameter.searchContent.trim()
        }
        this.loading = true
        let { data } = await API.getRolesMemberList(this.parameter)
        this.total = data.total
        this.memberList = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
        throw new Error(error.message)
      }
    },

    /**
     * API 根据ID删除对应角色的成员
     * @param {Number} id 成员ID
     */
    async deletRoleManager(id) {
      let { code, message } = await API.deletRoleManager(id)
      if (code === 10000) {
        this.getRolesMemberList()
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * 添加成员
     */
    addMember() {
      this.$refs.addMemberDialog.show({ roleId: this.roleId })
    },

    /**
     * 删除成员
     * @param {Object} row 当前删除的行
     */
    deleteMember(row) {
      this.$confirm('此操作将删除该成员, 是否继续?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deletRoleManager(row.id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    /**
     * 每页显示条数发生改变时的回调
     * @param {Number} size 每页显示条数
     */
    sizeChange(size) {
      this.parameter.pageSize = size
      this.getRolesMemberList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     * @param {Number} current 当前页
     */
    currentChange(current) {
      this.parameter.pageNumber = current
      this.getRolesMemberList(false)
    },

    /**
     * 显示对话框
     * @param {Object} payload 当前行信息
     */
    show(payload) {
      this.visible = true
      this.roleId = payload.id
      this.roleName = payload.name
      this.parameter.roleId = payload.id
      this.getRolesMemberList()
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.$emit('update')
      this.visible = false
    },

    /**
     * 负责清除数据的方法
     */
    clear() {
      this.parameter = { ...parameter }
      this.memberList = []
      this.total = 0
      this.roleId = undefined
      this.roleName = undefined
    }
  }
}
</script>

<style lang="scss" scoped>
.role-tips {
  margin-bottom: 15px;
  span {
    font-weight: 600;
  }
}

.el-input {
  width: 380px;
  .el-select {
    width: 100px;
  }
  /deep/.el-input-group__prepend {
    border-top-left-radius: 18px !important;
    border-bottom-left-radius: 18px !important;
  }
  /deep/.el-input-group__prepend {
    background-color: #fff !important;
  }
  /deep/.el-input-group__append {
    border-top-right-radius: 18px !important;
    border-bottom-right-radius: 18px !important;
  }
}
.add-member-btn,
.pagination {
  display: flex;
  justify-content: flex-end;
}

.add-member-btn {
  margin: 15px 0;
}

.el-table {
  width: 100%;
}

.pagination {
  margin-top: 15px;
}
</style>
